import gql from 'graphql-tag'
import { FieldsConfig } from '.'
import { buildMutationString } from './build-mutation-string'

// Visible for testing only
export function buildMutation<TFieldConfigKey extends string>({
  mutationName,
  fieldsConfig
}: {
  readonly mutationName: string
  readonly fieldsConfig: FieldsConfig<TFieldConfigKey>
}) {
  const mutationString = buildMutationString({ mutationName, fieldsConfig })
  return {
    mutationString,
    mutation: gql`
      ${mutationString}
    `
  }
}
